export default "__VITE_ASSET__CyiucTkd__"